import React, { useState, useEffect, createContext } from 'react';
import PropTypes from 'prop-types';

const SpauthServiceContext = createContext();
export const useSpauth = () => React.useContext(SpauthServiceContext);

export const Spauth = ({ appId, children }) => {
    const [userObj, setUserObj] = useState({});

    useEffect(() => {
        const spauthLogin = async () => {
            const userInfo = await window.SPAUTH.appId(appId)
                .useJWTforXHR()
                .login();

            setUserObj(userInfo);
        };

        spauthLogin();
    });

    return Object.keys(userObj).length ? (
        <SpauthServiceContext.Provider value={userObj}>
            {children}
        </SpauthServiceContext.Provider>
    ) : null;
};

Spauth.propTypes = {
    appId: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};
